import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="dashboard">
      <nav>
        <h1>Azure Demo Platform</h1>
        <div>
          <span>Welcome, {user?.email}</span>
          <button onClick={logout}>Logout</button>
        </div>
      </nav>

      <main>
        <h2>Dashboard</h2>
        <p>Welcome to your dashboard!</p>

        <div className="security-card" style={{
          marginTop: '30px',
          padding: '20px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          maxWidth: '500px'
        }}>
          <h3>🔒 Security Settings</h3>
          
          {!user?.two_factor_enabled ? (
            <>
              <p style={{ color: '#856404', background: '#fff3cd', padding: '10px', borderRadius: '4px' }}>
                ⚠️ Two-Factor Authentication is not enabled
              </p>
              <button 
                onClick={() => navigate('/setup-2fa')}
                style={{
                  marginTop: '15px',
                  padding: '10px 20px',
                  background: '#667eea',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px'
                }}
              >
                Enable 2FA
              </button>
            </>
          ) : (
            <p style={{ color: '#155724', background: '#d4edda', padding: '10px', borderRadius: '4px' }}>
              ✅ Two-Factor Authentication is enabled
            </p>
          )}
        </div>
<div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', maxWidth: '500px' }}>
  <h3>📊 Customer Management</h3>
  <p>View, edit, and manage your customer database</p>
  <button 
    onClick={() => navigate('/customers')}
    style={{
      marginTop: '15px',
      padding: '10px 20px',
      background: '#667eea',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '16px'
    }}
  >
    Manage Customers
  </button>
</div>
<div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ddd', borderRadius: '8px', maxWidth: '500px' }}>
  <h3>🏥 System Status</h3>
  <p>View real-time system health and uptime statistics</p>
  <button 
    onClick={() => navigate('/status')}
    style={{
      marginTop: '15px',
      padding: '10px 20px',
      background: '#667eea',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '16px'
    }}
  >
    View Status Page
  </button>
</div>
{user?.role === 'admin' && (
  <div className="admin-link" style={{
    marginTop: '20px',
    padding: '20px',
    border: '2px solid #667eea',
    borderRadius: '8px',
    maxWidth: '500px',
    background: '#f0f4ff'
  }}>
    <h3>🔧 Admin Access</h3>
    <p>You have administrator privileges</p>
    <button 
      onClick={() => navigate('/admin')}
      style={{
        padding: '10px 20px',
        background: '#667eea',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px'
      }}
    >
      Go to Admin Panel
    </button>
  </div>
)}
      </main>
    </div>
  );
};

export default Dashboard;
